import { useEffect, useState } from "react";
import { Plus, Lock } from "lucide-react";
import { api, formatTL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FeatureGate } from "@/components/SubscriptionGuards";
import { ContractForm } from "@/components/docs/ContractForm";
import { RegFormForm } from "@/components/docs/RegFormForm";
import { DocRow } from "@/components/docs/DocRow";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const DocList = ({ kind, Form, subtitle, label }) => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);
  const load = () => api.get(`/${kind}`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-3">
      <div className="flex justify-end"><Button data-testid={`new-${kind}-btn`} className="bg-slate-900" onClick={() => setForm({})}><Plus className="w-4 h-4 mr-1" />{label}</Button></div>
      {items.length === 0 ? <Card className="p-10 text-center text-sm text-slate-500">Henüz kayıt yok</Card>
        : items.map((d) => <DocRow key={d.id} kind={kind} d={d} subtitle={subtitle(d)} onEdit={(x) => setForm({ editing: x })} onChanged={load} />)}
      <Form open={!!form} editing={form?.editing} onClose={() => setForm(null)} onSaved={load} />
    </div>
  );
};

export default function ContractsPage() {
  const { hasFeature } = useAuth();
  const canContract = hasFeature("CONTRACT");
  const canForm = hasFeature("REG_FORM");
  return (
    <div className="space-y-6" data-testid="contracts-page">
      <div>
        <h1 className="text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Sözleşmeler</h1>
        <p className="text-slate-500 text-sm mt-1">Satış sözleşmelerini ve portföy kayıt (yetki) formlarını hazırlayın, PDF olarak alın.</p>
      </div>
      <Tabs defaultValue={canForm && !canContract ? "forms" : "contracts"}>
        <TabsList>
          <TabsTrigger value="contracts" data-testid="tab-contracts">{!canContract && <Lock className="w-3.5 h-3.5 mr-1.5" data-testid="tab-contracts-locked" />}Satış Sözleşmeleri</TabsTrigger>
          {canForm && <TabsTrigger value="forms" data-testid="tab-reg-forms">Kayıt Formları</TabsTrigger>}
        </TabsList>
        <TabsContent value="contracts" className="mt-4">
          <FeatureGate feature="CONTRACT">
            <DocList kind="contracts" Form={ContractForm} label="Yeni sözleşme"
              subtitle={(d) => `${d.seller?.name || "Satıcı -"} → ${d.buyer?.name || "Alıcı -"} · ${formatTL(d.sale_price)}`} />
          </FeatureGate>
        </TabsContent>
        {canForm && (
          <TabsContent value="forms" className="mt-4">
            <DocList kind="reg-forms" Form={RegFormForm} label="Yeni kayıt formu"
              subtitle={(d) => `${d.owner?.name || "Mal sahibi girilmedi"} · ${[d.district, d.city].filter(Boolean).join(", ")} · ${formatTL(d.asking_price)}`} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
